<template>
  <div class="recurring-signup-success">
    <div class="content">
      <h1>{{ $t('pages.recurring-success.headline') }}</h1>
      <p v-if="anyWeekday">{{ $t('pages.recurring-success.text-1') }}
        <span v-if="monday" class="selected-datetime" id="monday">{{ $t('components.day-time-picker.days.mon.long') }}</span>
        <span v-if="tuesday" class="selected-datetime" id="tuesday">{{ $t('components.day-time-picker.days.tue.long') }}</span>
        <span v-if="wednesday" class="selected-datetime" id="wednesday">{{ $t('components.day-time-picker.days.wed.long') }}</span>
        <span v-if="thursday" class="selected-datetime" id="thursday">{{ $t('components.day-time-picker.days.thu.long') }}</span>
        <span v-if="friday" class="selected-datetime" id="friday">{{ $t('components.day-time-picker.days.fri.long') }}</span>
        {{ $t('components.day-time-picker.at') }} <span class="selected-datetime">{{ time | localTimeString }}</span>
        {{ $t('components.day-time-picker.after-selection-text_3') }} <span class="selected-datetime">{{ phonenumber }}</span>
        {{ $t('pages.recurring-success.text-2') }}
      </p>
      <p v-if="!anyWeekday">{{ $t('pages.recurring-success.deactivated') }}</p>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'recurring-signup-success',
  props: {
    json: Object,
  },
  computed: {
    monday () {
      return this.$root.recurringPicker.weekday.Monday
    },
    tuesday () {
      return this.$root.recurringPicker.weekday.Tuesday
    },
    wednesday () {
      return this.$root.recurringPicker.weekday.Wednesday
    },
    thursday () {
      return this.$root.recurringPicker.weekday.Thursday
    },
    friday () {
      return this.$root.recurringPicker.weekday.Friday
    },
    time () {
      return this.$root.recurringPicker.time
    },
    phonenumber () {
      return this.$root.phonenumber.formatted
    },
    anyWeekday () {
      return this.monday ||
        this.tuesday ||
        this.wednesday ||
        this.thursday ||
        this.friday
    }
  },
  filters: {
    localTimeString (timeString) {
      return DateTime.fromISO(timeString).toLocaleString(DateTime.TIME_SIMPLE)
    }
  }
}
</script>


<style lang=scss>
@import '@/assets/styles/_variable.scss';

.recurring-signup-success {
  display: flex;
  flex-direction: column;

  .selected-datetime {
    background-color: $dark-text-color;
    color: $main-bg;
    font-size: 0.8em;
    padding: 5px 5px;
    margin: 0 1px;
    white-space: nowrap;
  }

  .content {
    min-height: 100vh;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1 {
      font-size: 3em;
      line-height: 1em;
      margin: 0em;
    }
    p {
      margin: 0.2em;

      span.highlight {
        background-color: $dark-red;
        color: $light-text-color;
        padding: 0 2px;
      }
    }
  }
}
</style>
